export const GetSmartFilterResults = Symbol.for('GetSmartFilterResults');
